import en from "./../lang/en";
import es from "./../lang/es";
import moment from "moment";
import "moment/locale/es";
import { stat } from "fs";

export const CHANGE_LANGUAGE = "internationalization/CHANGE_LANGUAGE";
export const CHANGE_TEMPERATURE_UNIT =
  "internationalization/CHANGE_TEMPERATURE_UNIT";
export const CHANGE_METRIC_UNIT = "internationalization/CHANGE_METRIC_UNIT";
export const CHANGE_VOLUME_UNIT = "internationalization/CHANGE_VOLUME_UNIT";

const initialState = {
  lang: es,
  temperatureUnit: "C",
  metricUnit: "Km",
  volumeUnit: "l"
};

moment.locale(es._code);

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      moment.locale(action.lang._code);
      return {
        ...state,
        lang: action.lang
      };
    case CHANGE_TEMPERATURE_UNIT:
      return {
        ...state,
        temperatureUnit: action.temperatureUnit
      };

    case CHANGE_METRIC_UNIT:
      return {
        ...state,
        metricUnit: action.metricUnit
      };

    case CHANGE_VOLUME_UNIT:
      return {
        ...state,
        volumeUnit: action.volumeUnit
      };
    default:
      return state;
  }
};

export const setLanguageES = () => {
  return dispatch => {
    dispatch({
      type: CHANGE_LANGUAGE,
      lang: es
    });
  };
};

export const changeTemperatureUnit = unit => {
  return dispatch => {
    dispatch({
      type: CHANGE_TEMPERATURE_UNIT,
      temperatureUnit: unit
    });
  };
};

export const changeMetricUnit = unit => {
  return dispatch => {
    dispatch({
      type: CHANGE_METRIC_UNIT,
      metricUnit: unit
    });
  };
};

export const changeVolumeUnit = unit => {
  return dispatch => {
    dispatch({
      type: CHANGE_VOLUME_UNIT,
      volumeUnit: unit
    });
  };
};

export const setLanguageEN = () => {
  return dispatch => {
    dispatch({
      type: CHANGE_LANGUAGE,
      lang: en
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/internationalization.js